// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__cGWVW","noInteraction":"EventWrapper_noInteraction__23wgt","pointerPassthrough":"EventWrapper_pointerPassthrough__1WGwQ"};